import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Globe } from "lucide-react";

// Bascule entre FR et EN en naviguant vers la route localisée miroir.
// La langue i18n est ensuite synchronisée par <LanguageSync /> au changement
// de route. On ne touche plus directement à i18n ici.
function counterpart(path) {
  if (path.startsWith("/en") && (path === "/en" || path.startsWith("/en/"))) {
    return path.slice(3) || "/";
  }
  return `/en${path === "/" ? "" : path}`;
}

export default function LanguageSwitcher() {
  const location = useLocation();
  const navigate = useNavigate();
  const isEn = location.pathname.startsWith("/en");
  const label = isEn ? "FR" : "EN";

  return (
    <button
      onClick={() => navigate(counterpart(location.pathname))}
      aria-label="Switch language"
      className="inline-flex items-center gap-1.5 px-3 h-9 rounded-full text-xs font-semibold border border-[#0985D8]/30 text-[#0985D8] hover:bg-[#0985D8]/10 transition-colors duration-200">
      <Globe className="w-3.5 h-3.5 text-[#0985D8]" />
      {label}
    </button>
  );
}